module.exports = __webpack_public_path__ + "static/media/bottom_banner_1_2.ae53dfa8.png";